import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { useDispatch, useSelector } from "react-redux";
import { getPaymentOptions, is } from "../thunk";
import { Icon } from "ccui-framework";
import { setSelectedPaymentMethod } from "../action";
import { FormatSelectedOptionButton } from "./FormatSelectedOptionButton";
import { RadioFormattedOptions } from "./RadioFormattedOptions";
import { PAYMENT_TYPES } from "../constant";
import { CLink } from "../../Anchor";

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const ChangeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5rem;
`;

const Change = styled.span`
  color: #ac936a;
  font-size: 14px;
  padding-right: 0.7rem;
  cursor: pointer;
`;

const NoDefaultMethod = styled.p`
  align-items: center;
  justify-content: center;
  display: flex;
  margin: 1rem;
  font-weight: bold;
`;

const OrderPaymentOptions = () => {
  const dispatch = useDispatch();
  const paymentMethods = useSelector((state) => state.paymentMethods);
  const [defaultMethod, setDefaultMethod] = useState({});
  const { methods, selectedMethod } = paymentMethods;
  const [changeOption, setChangeOption] = useState(false);

  useEffect(() => {
    dispatch(getPaymentOptions());

    return () => {
      setChangeOption(false);
      dispatch(setSelectedPaymentMethod({}));
    };
  }, []);

  // if no default method
  // select the first method and check for ACH_BULK
  // if ACH_BULK use it as defaut method
  // otherwise display message to select a default method
  useEffect(() => {
    if (methods.length) {
      let hasDefault = methods.find((m) => m.default);
      setDefaultMethod(
        hasDefault !== undefined
          ? hasDefault
          : is(methods[0].paymentMethod, PAYMENT_TYPES.ACH_BULK)
          ? methods[0]
          : undefined
      );
    }

    return () => setDefaultMethod({});
  }, [methods]);

  if (methods && changeOption) {
    return (
      <Container>
        <RadioFormattedOptions />

        {selectedMethod && (
          <FormatSelectedOptionButton selectedMethod={selectedMethod} />
        )}
      </Container>
    );
  }

  if (methods && !changeOption) {
    return (
      <Container>
        {!defaultMethod && (
          <NoDefaultMethod>
            <CLink to={"/account/payment-methods"}>
              Please click here to navigate to select a default payment option.
            </CLink>
          </NoDefaultMethod>
        )}

        {defaultMethod && (
          <>
            <FormatSelectedOptionButton selectedMethod={defaultMethod} />
            <ChangeContainer
              onClick={(e) => {
                e.preventDefault();
                setChangeOption(true);
                dispatch(setSelectedPaymentMethod(defaultMethod));
              }}
            >
              <Change>change</Change> <Icon name="fa-caret-right" />
            </ChangeContainer>
          </>
        )}
      </Container>
    );
  }

  return null;
};

export { OrderPaymentOptions };
